import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './ToggleSwitch.css';

const ToggleSwitch = props => {
  const { isOn, onToggle, label, className, defaultState, disabled } = props;

  const active = isOn != null ? isOn : defaultState;

  return (
    <div className={classNames(css.root, className, { [css.rootDisabled]: disabled })}>
      <button
        type="button"
        className={css.toggleButton}
        onClick={disabled ? undefined : () => onToggle(!active)}
        disabled={disabled}
        aria-pressed={active}
        aria-disabled={disabled || undefined}
        aria-label={typeof label === 'string' ? label : undefined}
      >
        <div className={classNames(css.track, active && css.trackOn)}>
          <div className={classNames(css.thumb, active && css.thumbOn)} />
        </div>
      </button>
      {label ? <span className={css.label}>{label}</span> : null}
    </div>
  );
};

ToggleSwitch.defaultProps = {
  isOn: null,
  className: null,
  label: null,
  defaultState: true,
  disabled: false,
};

ToggleSwitch.propTypes = {
  isOn: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  defaultState: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ToggleSwitch;
